import { Component, Input, OnInit } from '@angular/core';
import { Contract } from 'src/app/classes';

@Component({
  selector: 'app-contract-label',
  templateUrl: './contract-label.component.html',
  styleUrls: ['./contract-label.component.css']
})
export class ContractLabelComponent implements OnInit {

  @Input() contract: Contract;

  constructor() { }

  ngOnInit(): void {
  }

}
